import { Dialog, Transition } from '@headlessui/react';
import React, { Fragment, useState } from 'react';
import { WMSFetch } from '../../utils/common-api-calls';
import { STOCK_CHECK_STATUSES } from '../../pages/WMS_SMS/data';

export default function StockCheckModal({ setData, stockCheckData, setStockCheckData, currentUser, setShowNotification }) {
    const [loading, setLoading] = useState(false);
    const [comments, setComments] = useState(null);

    const closeModal = () => {
        setStockCheckData(null);
        setComments(null);
    }

    const submitStockCheck = async () => {
        try {
            setLoading(true);
            const body = {
                inventoryId: stockCheckData.inventoryId,
                internalComments: comments,
                ownerId: currentUser.authentication.userId
            };
            const data = await WMSFetch('wms/sms/create-stock-check', body, currentUser);
            if (data?.error) {
                throw Error(data.error);
            }
            updateStockCheckStatus(stockCheckData?.inventoryId);
            closeModal();
        } catch (error) {
            setShowNotification({
                shown: true,
                status: 'error',
                title: 'Error submitting Stock Check.',
                message:
                    'An error has occured submitting the Stock Check. If the error persists please contact your manager.',
            });
        } finally {
            setLoading(false);
        }
    };

    /**
     * Updates inventory line stock check status that runs when "Stock Check" button is clicked
     * @param {*} id
     */
    const updateStockCheckStatus = (id) => {
        setData((prevData) => {
            const updated = {
                ...prevData,
                inventoryLines: prevData.inventoryLines.map((line) =>
                    line.id === id ? { ...line, stockCheckStatus: STOCK_CHECK_STATUSES.IN_PROCESS } : line
                ),
            };
            return updated;
        });
    };

    return (
        <Transition.Root show={stockCheckData ? true : false} as={Fragment}>
            <Dialog as='div' className='relative z-30' onClose={() => closeModal()}>
                <div className='fixed w-full h-full top-0 left-0 flex items-center justify-center'>
                    <Transition.Child
                        as={Fragment}
                        enter='ease-out duration-300'
                        enterFrom='opacity-0'
                        enterTo='opacity-100'
                        leave='ease-in duration-200'
                        leaveFrom='opacity-100'
                        leaveTo='opacity-0'
                    >
                        <div className='fixed w-screen h-screen z-20 inset-0 bg-gray-500 bg-opacity-40 transition-opacity' />
                    </Transition.Child>
                    <div className='relative flex flex-col items-end justify-between h-fit w-[500px] border rounded-md px-5 pb-5 pt-3 bg-white gap-y-3 z-30'>
                        <h1 className='w-full text-center text-lg'>Stock Check Confirmation</h1>
                        <section className='w-full h-fit flex-col'>
                            <textarea value={comments} onChange={(e) => setComments(e.currentTarget.value)} placeholder='Add Internal Comments Here...' className='border rounded-md w-full h-[200px] p-2 resize-none' />
                        </section>
                        <section className='w-full h-fit flex flex-row justify-evenly gap-x-5'>
                            <button
                                disabled={loading}
                                className='bg-gray-300 text-black rounded-md px-2 py-1 w-full disabled:opacity-40'
                                onClick={() => closeModal()}
                            >
                                Cancel
                            </button>
                            <button
                                disabled={loading}
                                className='bg-blue-primary text-white rounded-md px-2 py-1 w-full disabled:opacity-40'
                                onClick={() => {
                                    submitStockCheck();
                                }}
                            >
                                {loading ? 'Submitting' : 'Submit Stock Check'}
                            </button>
                        </section>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}
